import React from 'react';
import { PageHeader } from '@/components/common/PageHeader';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users } from 'lucide-react';

const Community = () => {
  return (
    <div className="space-y-6">
      <PageHeader 
        title="Community" 
        description="Connect with other coaches"
      />
      
      <div className="grid gap-6 md:grid-cols-2">
        <Card>
          <CardContent className="pt-6">
            <div className="flex flex-col items-center space-y-4 text-center">
              <Users className="h-12 w-12 text-muted-foreground" />
              <h3 className="text-xl font-semibold">Join Our Community</h3>
              <p className="text-muted-foreground">
                Connect with other coaches, share experiences, and grow together.
              </p>
              <Button onClick={() => window.open('https://communities.coachmakin.com', '_blank')}>
                Join Community Forum
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Community;
